import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const StyledTypography = styled(Typography)(({ fontFamily }) => ({
  fontFamily: `${fontFamily} !important`
}));



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/plugin-details/VpPluginFontFamilySelect/styles.js